export enum Themes {
  primary = "primary",
  danger = "danger",
  warning = "warning",
  iconButton = "iconButton",
  success = "success",
  white = "white",
  declarative = "declarative",
  blue = "blue",
  red = "red",
  gray = "gray"
}
